import { first, last, map, mergeMap } from 'rxjs/operators';
import { Subscription, filter } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd, Routes } from '@angular/router';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ContentChildren,
  OnInit,
  QueryList,
} from '@angular/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterContentInit {

  fullscreenMode: boolean = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  RedirectHome() {
    this.router.navigate(['/Home']);
  }

  activeComponent!: any;

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
  }

  getCurrentDateTime(): Date {
    return new Date();
  }


  ngOnDestroy(): void {
  }

  redirect(url: any) {
    this.router.navigate([url]);
  }

  unsubscribe() {
  }
}
